import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSportsVolleyball = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSportsVolleyball",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M864-592 520-791v-87q123 12 216 91t128 195M270-404v-416q39-23 82-38t89-20v375zm-154 89q-18-38-27-79t-9-86q0-77 28-147t82-127v395zm176 187q-42-20-76-50t-60-68l325-188 171 99zm189 48-47-2q-24-2-46-9l344-198 74 41q-57 78-142 123T481-80m364-236L520-503v-197l360 209q0 46-8 90t-27 85"
  })
}));
IconSportsVolleyball.displayName = 'IconSportsVolleyball';